<template>
  <div class="instructor">
    <page-header />
    <audit-temp :audit_status="final_audit_status" :audit_remark="final_audit_remark" />
    <page-prompt />
    <section class="main">
      <h2 class="title">指导教师</h2>
      <div class="msgs">
        <div class="teacher" v-for="item of instructor_list" :key="item.id">
          <ul>
            <li>
              <label>姓名：</label>
              <span>{{ item.name }}</span>
            </li>
            <li>
              <label>身份证号：</label>
              <span>{{ item.identity }}</span>
            </li>
            <li>
              <label>性别：</label>
              <span>{{ sex_config_obj[item.sex] }}</span>
            </li>
            <li>
              <label>手机号：</label>
              <span>{{ item.phone }}</span>
            </li>
            <li>
              <label>电子邮箱：</label>
              <span>{{ item.email }}</span>
            </li>
            <li>
              <label>学校名称：</label>
              <span>{{ item.school_name }}</span>
            </li>
            <li>
              <label>学院名称：</label>
              <span>{{ item.college }}</span>
            </li>
            <li>
              <label>专业名称：</label>
              <span>{{ item.major }}</span>
            </li>
            <li>
              <label>职称：</label>
              <span>{{ item.professional }}</span>
            </li>
            <li>
              <label>工号：</label>
              <span>{{ item.work_id || '未填' }}</span>
            </li>
            <li>
              <label>入职年份：</label>
              <span>{{ item.dates || '未填' }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
        <el-button type="primary" icon="el-icon-right" @click="onNextPage">下一项</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AuditTemp from '@/components/AuditTemp'
import PagePrompt from '@/components/PagePrompt'
import { fetchInstructorList } from '@/service/api'

export default {
  name: 'PageInstructor',
  components: {
    PageHeader,
    AuditTemp,
    PagePrompt
  },
  data () {
    return {
      final_audit_status: 3,
      final_audit_remark: '',
      sex_config_obj: {
        1: '男',
        2: '女'
      },
      instructor_list: []
    }
  },
  methods: {
    onPrevPage () {
      this.$router.push('/team')
    },
    onNextPage () {
      this.$router.push('/works')
    },
    async getInstructorList () {
      try {
        const data = await fetchInstructorList()
        this.instructor_list = data.reg_instructor_list
        this.final_audit_status = data.reg_team_basic.final_audit_status
        this.final_audit_remark = data.reg_team_basic.final_audit_remark
      } catch (error) {
        console.log('getInstructorList error', error)
      }
    }
  },
  mounted () {
    document.body.style.height = 'auto'
    this.getInstructorList()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
